"use client"

import { useMutation } from "@tanstack/react-query"

import { useTranslatedQueryHandling } from "@/hooks/use-translated-query-handling"

import {
  importKnowledgeBaseFromSocialAction,
  type ImportKnowledgeBaseFromSocialInput,
  type ImportKnowledgeBaseFromSocialResult,
} from "@/server-actions/knowledge-base-social-import"
import { useTranslations } from "next-intl"


export type ImportKnowledgeBaseFromSocialMutationInput =
  ImportKnowledgeBaseFromSocialInput & {
    setErrors?: (errors: Record<string, unknown>) => void
  }

export function useImportKnowledgeBaseFromSocialMutation(options?: {
  onSuccess?: (result: ImportKnowledgeBaseFromSocialResult) => void | Promise<void>
}) {
  const withQueryHandling = useTranslatedQueryHandling()

  const tUi = useTranslations("Feedback.MutationsKnowledgeBaseSocialImport")

  return useMutation({
    mutationFn: async ({ setErrors, ...input }: ImportKnowledgeBaseFromSocialMutationInput) => {
      const result = await withQueryHandling(
        importKnowledgeBaseFromSocialAction(input),
        {
          loading: tUi("startingSocialProfileImport"),
          success: tUi("socialProfileImportStarted"),
          setErrors,
        },
      )
      return result as ImportKnowledgeBaseFromSocialResult
    },
    onSuccess: options?.onSuccess,
  })
}
